import { render, staticRenderFns } from "./contributeAdd.vue?vue&type=template&id=e2cd0c28&scoped=true"
import script from "./contributeAdd.vue?vue&type=script&lang=js"
export * from "./contributeAdd.vue?vue&type=script&lang=js"
import style0 from "./contributeAdd.vue?vue&type=style&index=0&id=e2cd0c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cd0c28",
  null
  
)

export default component.exports